<template>
	<tr class="TeklifOffersOfferProductLine">
		<td>
			<v-combobox 
			v-model="input_product_name" 
			:search-input.sync="input_product_name_search"
			:items="products" 
			item-text="name" 
			item-value="name" hide-details class="lineProductName"> </v-combobox>
			<textarea class="inputXs  " v-model="input_product_description" ></textarea>
			<!-- <div class="lineDescription">
				<span class="label">AÇIKLAMA</span>
				<input type="text" class="inputXs" :label="placeholder" v-model="price_model" v-on:blur="onBlur()">
			</div> -->
		</td>

		<td>
			<FloatInputBox v-model="input_adet" />
		</td>
		<td>
			<FloatInputBox v-model="input_fiyat" />
		</td>
		<td>
			<FloatInputBox v-model="input_indirim_miktari" />
		</td>
		<td>
			<select class="inputXs inputXsSelect" v-model="input_kdv_orani">
				<option v-for="(kdv,kdvIndex) in kdvs" :key="'kdv-'+kdvIndex" :value="kdv.value">{{kdv.text}}</option> 
			</select>
		</td>


		<td>
			<FloatInputBox v-model="input_genel_toplam" readonly/>
		</td>

		<td>
			<button class="productLineRemove" @click="removeThisLine()">x</button>
		</td>
	</tr>
</template>

<script>
	import FloatSpan from "@/components/tools/FloatSpan.vue";
	import FloatInputBox from "@/components/tools/FloatInputBox.vue";
	export default {
		name: "TeklifOffersOfferProductLine",
		components: {
			FloatSpan,
			FloatInputBox,
		},
		props: { 
			products: {
				type : Array
			},
			kdvs: {
				type : Array
			},
			productLine: {
				type : Object
			},
		},
		model: {
			prop: 'productLine',
			event: 'input'
		},
		data() {
			return { 
				product_value : "",
				input_product_name: "",
				input_product_name_search : "",
				input_product_description: "",
				input_adet: 1.0,
				input_fiyat: 0.0,
				input_ara_toplam: 0.0,
				input_indirim_miktari: 0.0,
				input_indirim_tipi: "%",
				input_indirim_toplam: 0.0,
				input_burut_toplam: 0.0,
				input_kdv_orani: "18",
				input_kdv_miktari: 0.0,
				input_genel_toplam: 0.0
			}
		},
		watch: {
			"input_product_name": function (n,o) { 
				if(typeof n == "object"){
					this.input_fiyat = parseFloat(n.price)
					this.input_product_name = n.name
					this.input_product_description = n.description
				}else{
					this.emitMe()
				}
			},
			"input_product_name_search": function (n,o) { 
				this.input_product_name = n
			},
			"input_product_description": function () { 
				this.calcTotals();
			},
			"input_adet": function () {
				this.calcTotals();
			},
			"input_fiyat": function () {
				this.calcTotals();
			},
			"input_indirim_miktari": function () {
				this.calcTotals();
			},
			"input_indirim_tipi": function () {
				this.calcTotals();
			},
			"input_kdv_orani": function () {
				this.calcTotals();
			}, 
		},
		mounted(){
			this.input_product_name = this.productLine.product_name || "";
			this.input_product_description = this.productLine.product_description || "";
			this.input_adet = this.productLine.adet || 1.0;
			this.input_fiyat = this.productLine.fiyat || 0.0;
			this.input_ara_toplam = this.productLine.ara_toplam || 0.0;
			this.input_indirim_miktari = this.productLine.indirim_miktari || 0.0;
			this.input_indirim_tipi = this.productLine.indirim_tipi || "%";
			this.input_indirim_toplam = this.productLine.indirim_toplam || 0.0;
			this.input_burut_toplam = this.productLine.burut_toplam || 0.0; 
			this.input_kdv_orani = this.productLine.kdv_orani || "0";
			this.input_kdv_miktari = this.productLine.kdv_miktari || 0.0;
			this.input_genel_toplam = this.productLine.genel_toplam || 0.0;
		},
		methods: {
			calcTotals() {
				this.input_ara_toplam = parseFloat(parseFloat(this.input_adet) * parseFloat(this.input_fiyat))
				if(this.input_indirim_tipi == "%"){
					this.input_indirim_toplam = parseFloat(this.input_ara_toplam / 100 * parseFloat(this.input_indirim_miktari || 0))
				}
				else{
					this.input_indirim_toplam = parseFloat(this.input_indirim_miktari || 0)
				}
				this.input_burut_toplam = parseFloat(this.input_ara_toplam - this.input_indirim_toplam)

				this.input_kdv_miktari = this.input_burut_toplam / 100 * parseInt(this.input_kdv_orani)
				
				this.input_genel_toplam = parseFloat(parseFloat(this.input_burut_toplam) + parseFloat(this.input_kdv_miktari))
				this.emitMe()
			},
 
			emitMe(){
				this.$emit("input",{
					product_name : this.input_product_name,
					product_description : this.input_product_description,
					adet : parseFloat(this.input_adet),
					fiyat : parseFloat(this.input_fiyat),
					ara_toplam : parseFloat(this.input_ara_toplam), 
					indirim_miktari : parseFloat(this.input_indirim_miktari), 
					indirim_tipi : this.input_indirim_tipi, 
					indirim_toplam : parseFloat(this.input_indirim_toplam), 
					burut_toplam : parseFloat(this.input_burut_toplam), 
					kdv_orani : parseFloat(this.input_kdv_orani), 
					kdv_miktari : parseFloat(this.input_kdv_miktari), 
					genel_toplam : parseFloat(this.input_genel_toplam), 
				})
			},
			removeThisLine(){
				this.$emit("remove",true);
			}
		}

	}
</script>

<style lang="less">
	.TeklifOffersOfferProductLine {
		td {
			border-bottom: 2px solid #ccc;
			vertical-align: top;
		}
 
		.lineProductName{ 
			margin: 0px 0px 8px 0px;
			padding: 0px;
			color: #404040;
			background-color: #fff;
			background-image: none;
			border: 1px solid #d5d8de;
			border-radius: 2px;
			-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
			box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
			-webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			-o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			-webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			input{
				padding-left:6px;
			}
		}

		.inputXs {
			display: block;
			width: 100%;
			font-size: 13px;
			line-height: 1.428571429;
			color: #404040;
			background-color: #fff;
			background-image: none;
			border: 1px solid #d5d8de;
			border-radius: 2px;
			-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
			box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
			-webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			-o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			-webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
			transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
			&select{
				height: 30px;
			}
			&textarea{
				height:auto !important;
			}
			font-size: 12px;
			padding: 6px 9px;

			&.inputXsSelect {
				-webkit-appearance: auto;
				appearance: auto;
			}

			&:focus {
				border-color: #4285f4;
				outline: 0;
			}
		}

		.flexer {
			display: flex;

			.flexcol {
				width: calc(~"50% - 10px");

				&:first-child {
					margin-right: 20px;
				}
			}
		}

		.lineDescription {
			margin-top: 10px;
			display: flex;
			width: 100%;

			.label {
				padding: 0px 10px;
				line-height: 30px;
				height: 30px;
				font-size: 12px;
				font-family: "Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
				font-weight: 700;
				color: #929292;
				background-color: whitesmoke;
				border: 1px solid #d5d8de;
				border-top-left-radius: 2px;
				border-bottom-left-radius: 2px;
			}
		}

		.productLineRemove {
			display: block;
			background-color: rgb(207, 26, 26);
			color: #fff;
			height: 30px;
			width: 30px;
			line-height: 30px;
			border: none;
			text-align: center;
			border-radius: 2px;
			outline: none;

			&:hover {
				background-color: rgb(143, 19, 19)
			}
		}
	}
</style>